import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import type { PropsWithChildren } from 'react'
import { queryClient } from '@/shared/provider/query-client/query-client.ts'

export interface QueryProviderProps {
	disableRetry: boolean
}

export function QueryProvider({
	disableRetry,
	children,
}: Readonly<PropsWithChildren<QueryProviderProps>>) {
	return (
		<QueryClientProvider client={queryClient({ disableRetry })}>
			{children}
			{import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
		</QueryClientProvider>
	)
}
